import { sum } from 'd3-array';

export const getAverageTimeSeries = (timeSeriesList, accessors) => {
    const { xAccessor, yAccessor, predictionAccessor } = accessors;

    const mapByXValue = new Map();
    let header;
    timeSeriesList.forEach(({ timeSeries }) => {
        // Collapse each series to a single value per date before aggregating.
        // Some series contain duplicate dated rows (a data-pipeline artifact in
        // tiktok_data_store.time_series); counting them would both inflate the
        // combined total and, in the old in-loop summation, crash once `data`
        // had been reduced to a number and `.push` was called on it again.
        const seenInSeries = new Set();
        timeSeries.forEach((row, rowIdx) => {
            if (rowIdx < 1) {
                header = row;
                return;
            }
            const x = xAccessor(row);
            const y = yAccessor(row);
            const isPrediction = predictionAccessor(row);

            if (!mapByXValue.has(x)) {
                mapByXValue.set(x, { data: [], isPrediction: false });
            }

            const currentX = mapByXValue.get(x);
            if (!seenInSeries.has(x)) {
                seenInSeries.add(x);
                currentX.data.push(y);
            }
            if (isPrediction) currentX.isPrediction = true;
        });
    });

    // Sum each date's per-series values AFTER processing every series, so the
    // combined line carries one number per date (cross-series sum), reduced
    // exactly once.
    mapByXValue.forEach((currentX) => {
        currentX.data = sum(currentX.data);
    });

    let averageTimeSeries = [header];
    const headerLen = Object.values(header).length;
    mapByXValue.forEach(({ data, isPrediction }, date) => {
        const row = new Array(headerLen);
        row[header.date] = date;
        row[header.real_volume] = data;
        row[header.prediction] = isPrediction;
        averageTimeSeries.push(row);
    });
    // sort timeseries data chronologically
    averageTimeSeries = averageTimeSeries.sort((a, b) => {
        const dateA = new Date(a[header.date]);
        const dateB = new Date(b[header.date]);
        return dateA - dateB;
    });
    return averageTimeSeries;
};
